// extracted by mini-css-extract-plugin
export default {"description":"fZCQn8","harmony":"pgDA6x"};